/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TechnicalVisitAliases {
  AVATAR = 'avatar',
  BUTTOMS = 'buttoms',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_1 = 'contextual-bar-1',
  DECK_APPOINTMENTS = 'deck-appointments',
  DECK_VISIT = 'deck-visit',
  FETCH_APPOINTMENTS = 'fetch-appointments',
  FETCH_VISIT = 'fetch-visit',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_DATE = 'field-date',
  FORM_MESSAGE = 'form-message',
  HPMS_CUSTOM_CARD_APPOINTMENTS = 'hpms-custom-card-appointments',
  HPMS_CUSTOM_CARD_VISIT = 'hpms-custom-card-visit',
  LAYOUT_0 = 'layout-0',
  MODAL_REFUSE = 'modal-refuse',
  PANEL_APPOINTMENTS = 'panel-appointments',
  PANEL_CONTENT = 'panel-content',
  PANEL_CONTENT_VISTIT = 'panel-content-vistit',
  PANEL_MAIN = 'panel-main',
  PANEL_MODAL = 'panel-modal',
  PANEL_VISIT = 'panel-visit',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_AREA_0 = 'text-area-0',
}
export { TechnicalVisitAliases };
